import dayjs, { Dayjs } from 'dayjs';

export const startOfDate = (date: Dayjs) =>
  dayjs(dayjs(date.format('YYYY-MM-DD')).unix() * 1000).toISOString();

export const endOfDate = (date: Dayjs) =>
  dayjs(
    dayjs(date.add(1, 'day').format('YYYY-MM-DD')).unix() * 1000 - 1,
  ).toISOString();

export const formatTimeHourMinute = (time: string | number | Date | Dayjs) =>
  dayjs(time).format('HH:mm');

export const formatTimeHourDate = (time: string | number | Date | Dayjs) =>
  dayjs(time).format('YYYY/MM/DD');

export const formatTime = (time: string) =>
  dayjs(time).format('YYYY/MM/DD HH:mm');

export const fileSizeFormat = (bytes: number) => {
  const integer = Math.trunc(bytes);
  for (const n of [
    { number: 1000000000000, unit: 'TB' },
    { number: 1000000000, unit: 'GB' },
    { number: 1000000, unit: 'MB' },
    { number: 1000, unit: 'KB' },
  ]) {
    if (integer >= n.number) {
      return {
        size: Number((integer / n.number).toFixed(2)),
        unit: n.unit,
      };
    }
  }
  return {
    size: Number(integer.toFixed(2)),
    unit: 'B',
  };
};
